export const getValidationError = ({ input, validation }) => {
    for (let rule of validation) {
        if (!rule.isValid(input)) {
            return rule.errorMsg;
        }
    }

    return null;
};
